import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {User} from '../../../graphql/auth';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {gqlUser} from '../getUser.api';

export interface CreateUserVars {
    data: {
        first_name: string
        last_name: string
        email: string
        password: string
        email_verified?: boolean,
        email_opt_out?: boolean,
        sms_opt_out?: boolean,
        admin_verified: boolean,
        values?: boolean,
        cellphone: string,
        cellphone_code: string,
        roles?: {
            connect: number[],
        }
    };
}

interface CreateUserData {
    createUser: User
}

export const CREATE_USER_MUTATION = gql`
    mutation createUser($data: CreateUserInput!) {
        createUser(data: $data) {
            ${gqlUser}
        }
    }
`;

export const createUser = () => useMutation<CreateUserData, CreateUserVars>(
    CREATE_USER_MUTATION,
    {
        update: updateCacheByType('User'),
    }
);

export default createUser;